/**
 * Created by linjianxi on 2016/10/29.
 */
import * as types from './mutation-type'
import * as http from '../../../utils/common'
/**
 * 获取验证码
 * @param commit
 * @param params
 */
export const userDetailInfo = ({commit}, params) => {
  /* if (dataValidator(params)) {
   let retData
   let time = 60
   commit(types.TIME_COUNT, {isAct: false})
   let count = setInterval(function () {
   if (time > 1) {
   time--
   commit(types.COUNT_DOWN, {time: time, isShow: false, result: retData.data, isYes: true, isAct: true})
   } else {
   time = 60
   commit(types.COUNT_DOWN, {time: time, isShow: true, result: retData.data, isYes: true, isAct: true})
   clearInterval(count)
   }
   }, 1000)
   http.post({
   url: '/api/FundUserBind/UserDetailInfo',
   data: params.data,
   succ: function (res) {
   if (res.result === 1) {
   retData = res
   } else {
   commit(types.TIME_COUNT, {isAct: true})
   clearInterval(count)
   alert(res.message)
   }
   }
   }, params._this.$store.commit)
   } */
  if (dataValidator(params)) {
    let time = 60
    let count
    commit(types.TIME_COUNT, {isAct: false})
    http.post({
      url: '/api/FundUserBind/UserDetailInfo',
      data: params.data,
      succ: function (res) {
        if (res.result === 1) {
          count = setInterval(function () {
            if (time > 1) {
              time--
              commit(types.COUNT_DOWN, {time: time, isShow: false, result: res.data, isYes: true, isAct: true})
            } else {
              time = 60
              commit(types.COUNT_DOWN, {time: time, isShow: true, result: res.data, isYes: true, isAct: true})
              clearInterval(count)
            }
          }, 1000)
        } else {
          commit(types.TIME_COUNT, {isAct: true})
          clearInterval(count)
          alert(res.message)
        }
      }
    }, params._this.$store.commit)
  }
}

/**
 * 绑定用户信息和银行卡
 * @param commit
 * @param params
 */
export const verifySnsCode = ({commit}, params) => {
  if (dataValidator(params)) {
    http.post({
      url: '/api/FundUserBind/VerifySnsCode',
      data: params.data,
      succ: function (res) {
        if (res.result === 1) {
          let p = new Promise(function (resolve, reject) {
            mui.alert(res.message, function () {
              resolve()
            })
          })
          p.then(function () {
            /* if (res.data.isidcardimage !== 1) {
              let returl = encodeURIComponent(window.location.origin + window.location.pathname + '#/hqpord/index')
              window.location.href = res.data.backurl + `?back_url=${returl}`
            } else {
              params._this.$router.replace({path: '/hqpord/index'})
            } */
           /* if (res.data.isidcardimage !== 1) {
              window.location.href = res.data.backurl + `?back_url=${params._this.fromUrl}`
            } else {
              window.location.replace(decodeURIComponent(params._this.fromUrl))
            } */
            if (params._this.$route.query.from !== undefined) { // 红包跳转到活期宝页
              params._this.$router.replace({path: '/hqpord/into', query: {amount: params._this.amount, from: 'red', redId: params._this.couponid}})
            } else {
              params._this.$router.replace({path: '/hqpord/into'})
            }
          })
        } else {
          alert(res.message)
        }
      }
    }, params._this.$store.commit)
  }
}

// 验证
export const dataValidator = (params) => {
  if (params.data.BankCode === '') {
    alert('请选择开户行')
    return false
  } else if (params.data.BankCard === '') {
    alert('请输入银行卡号')
    return false
  } else if (params.data.MobilePhone === '') {
    alert('请填写手机号码')
    return false
  } else if (params.data.SmsCode === '') {
    alert('请填写验证码')
    return false
  } else {
    return true
  }
}




// WEBPACK FOOTER //
// ./src/vuex/modules/card_bind/actions.js